/* 🤖 this file was generated by svg-to-ts */
export const iconCoinbasewallet: {
  name: 'coinbasewallet';
  data: string;
} = {
  name: 'coinbasewallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#2151F4" d="M16 0c8.84 0 16 7.16 16 16s-7.16 16-16 16S0 24.84 0 16 7.16 0 16 0"/><path fill="#fff" d="M16.01 21.62c-3.11 0-5.62-2.52-5.62-5.62s2.52-5.62 5.62-5.62c2.78 0 5.1 2.03 5.54 4.69h5.67C26.74 9.3 21.91 4.76 16.01 4.76 9.8 4.76 4.76 9.8 4.76 16.01S9.8 27.26 16.01 27.26s10.73-4.54 11.21-10.31h-5.67c-.45 2.66-2.75 4.69-5.54 4.69z"/></svg>`,
};
